 let lastScrollY = window.scrollY;
 const stickyBar = document.getElementById("FabrichStickyBar");

  window.addEventListener("scroll", () => {
    if (window.scrollY > lastScrollY) {
         stickyBar.style.bottom = "0"; // Show bar when scrolling down
    } else {
    stickyBar.style.bottom = "-100px"; // Hide when scrolling up
      }
    lastScrollY = window.scrollY;
  });